<div
  class="message text-grey_900 pointer-none m-auto p-2 mt-2.5 -mb-2.5 text-center"
  *ngIf="message.body !== '<p><br></p>'"
  [innerHTML]="message?.body"
></div>
